import { Link } from 'react-router-dom';
import type { Actor } from '@/types';

export default function ActorCard({ actor }: { actor: Actor }) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-secondary-300 transition-colors">
      <div className="flex gap-4 p-4">
        <div className="shrink-0 w-20 h-24 md:w-24 md:h-28 rounded-md overflow-hidden">
          <img
            src={actor.photo}
            alt={`演员 ${actor.name} 写真`}
            title={`${actor.name} 演员动态`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-heading text-base font-bold text-foreground-950">{actor.name}</h3>
            <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-label whitespace-nowrap">
              {actor.region}
            </span>
            <span className="px-2 py-0.5 rounded-full bg-background-200 text-foreground-600 text-xs font-label whitespace-nowrap">
              {actor.gender}
            </span>
          </div>
          <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">{actor.summary}</p>
        </div>
      </div>
      <div className="px-4 pb-4">
        <p className="text-xs font-label text-foreground-500 mb-2">最新动态</p>
        <div className="flex flex-col gap-2">
          {actor.latestNews.map((news) => (
            <Link
              key={`${actor.id}-${news.newsId}`}
              to={`/detail/news/${news.newsId}`}
              className="flex items-start gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-article-line mt-0.5 text-accent-500 shrink-0"></i>
              <span className="line-clamp-2">{news.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </article>
  );
}